import { useEffect } from "react";

const StructuredData = ({ language }) => {
  useEffect(() => {
    document.documentElement.lang = language || "en";

    const titles = {
      en: "Dakhla Kite Planet | Kitesurfing School in Dakhla, Morocco - IKO Certified",
      es: "Dakhla Kite Planet | Escuela de Kitesurf en Dakhla, Marruecos - Certificado IKO",
      de: "Dakhla Kite Planet | Kitesurfschule in Dakhla, Marokko - IKO Zertifiziert",
      fr: "Dakhla Kite Planet | Ecole de Kitesurf a Dakhla, Maroc - Certifie IKO",
    };
    document.title = titles[language] || titles.en;
  }, [language]);

  return null;
};

export default StructuredData;
